// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#3792cb","sidebarColorTop":"#3792cb","sidebarColorBottom":"#296d98"};